<template>
  <div class="w-1.5 h-5 rounded-md" :class="color"></div>
</template>
<script setup>
import { computed } from "vue";

const props = defineProps({
  status: {
    type: String,
  },
});

const color = computed(() => {
  switch (props.status) {
    case "open":
      return "bg-utility-gray-400";
    case "assigned":
      return "bg-utility-purple-500";
    case "completed":
      return "bg-utility-success-500";
    case "scheduled":
      return "bg-utility-blue-light-400";
    default:
      return "bg-utility-gray-400";
  }
});
</script>
